import React from 'react';
import { useLanguage } from './i18n/LanguageContext';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const { t } = useLanguage();
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-icon-container">
          <img
            src={process.env.PUBLIC_URL + '/images/location_pin.svg'}
            alt="Locating your hotel"
            className="location-pin-icon"
          />
          <div className="pin-shadow"></div>
        </div>
        
        <h2 className="loading-primary-text">{t('Identifying your stay...')}</h2>
        <p className="loading-secondary-text">{t('Scanning your nearby hotels...')}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
